module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 0 0",
      "height": "100%"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_vm._l((_vm.row.member_list), function(member, index) {
    return _c('div', {
      key: index
    }, [_c('van-cell-group', [_c('van-cell', {
      attrs: {
        "readonly": "",
        "input-align": "right",
        "title": '人员' + (index + 1),
        "label": member.num,
        "value": member.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "is-link": member.daoshioptions.length > 0,
        "title": "导师等级申报",
        "value": member.daoshishenbao,
        "label": '现有等级 ' + (member.daoshi ? member.daoshi : '无'),
        "input-align": "right"
      },
      on: {
        "click": function($event) {
          _vm.thisMemberIndex = index;
          _vm.thisMemberField = 'daoshishenbao';
          _vm.shenbaoTypeColumns = member.daoshioptions;
          _vm.showShenbaoTypePicker = true
        }
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goPre()
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 2), _vm._v(" "), (_vm.shenbaoTypeColumns.length > 0) ? _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showShenbaoTypePicker),
      callback: function($$v) {
        _vm.showShenbaoTypePicker = $$v
      },
      expression: "showShenbaoTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.shenbaoTypeColumns,
      "show-toolbar": "",
      "default-index": 0
    },
    on: {
      "cancel": function($event) {
        _vm.showShenbaoTypePicker = false
      },
      "confirm": _vm.onShenbaoTypeConfirm
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5192ac9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStep20.vue
// module id = 2397
// module chunks = 0